import React, { Fragment, useMemo } from 'react';
import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import useIncentivizedEarnings from '../../../../hooks/web3/vault/useIncentivizedEarnings';

const ClaimableIncentivizedEarnings: React.FC = () => {
    const { incentivizedEarnings } = useIncentivizedEarnings();

    const totalClaimable = useMemo(
        () =>
            incentivizedEarnings?.reduce(
                (total, { claimableAmount, usdValue }) =>
                    (total += +claimableAmount * +usdValue),
                0
            ),
        [incentivizedEarnings]
    );

    return (
        <Detail
            title={
                <>
                    <span>Your Claimable Incentivized Earnings</span>
                    <InfoPopUp className='total-incentivized-rewards'>
                        <span>Your Claimable Incentivized Earnings:</span>
                        <div className='mt'>
                            <span>Claimable Earnings:</span>
                            {incentivizedEarnings?.length ? (
                                incentivizedEarnings
                                    .filter(({ isRemoved }) => !isRemoved)
                                    .map(
                                        ({ claimableAmount, token, usdValue }, index) => (
                                            <Fragment key={index}>
                                                <strong
                                                    className={`block ${
                                                        index !== 0 ? 'mt' : ''
                                                    }`}
                                                >
                                                    {formatUSD(claimableAmount || 0)}{' '}
                                                    {token.symbol}
                                                </strong>
                                                <span className='block'>
                                                    {`(~$${formatUSD(
                                                        +claimableAmount * +usdValue || 0
                                                    )})`}
                                                </span>
                                            </Fragment>
                                        )
                                    )
                            ) : (
                                <strong className='block'>N/A</strong>
                            )}
                        </div>
                        <div className='mt border-top'>
                            <span>Claimed Earnings</span>
                            {incentivizedEarnings?.length ? (
                                incentivizedEarnings
                                    .filter(({ isRemoved }) => !isRemoved)
                                    .map(({ claimedAmount, token, usdValue }, index) => (
                                        <Fragment key={index}>
                                            <strong
                                                className={`block ${
                                                    index !== 0 ? 'mt' : ''
                                                }`}
                                            >
                                                {formatUSD(claimedAmount || 0)}{' '}
                                                {token.symbol}
                                            </strong>
                                            <span className='block'>
                                                {`(~$${formatUSD(
                                                    +claimedAmount * +usdValue || 0
                                                )})`}
                                            </span>
                                        </Fragment>
                                    ))
                            ) : (
                                <strong className='block'>N/A</strong>
                            )}
                        </div>
                    </InfoPopUp>
                </>
            }
            value={`~$${formatUSD(totalClaimable || 0)}`}
        />
    );
};

export default ClaimableIncentivizedEarnings;
